let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cKTv8")).then(() => parcelRequire('g1NL8'));